import { render, staticRenderFns } from "./PlusCoverImageUpload.vue?vue&type=template&id=6f2fc48d&scoped=true"
import script from "./PlusCoverImageUpload.vue?vue&type=script&lang=js"
export * from "./PlusCoverImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2fc48d",
  null
  
)

export default component.exports